import { render, staticRenderFns } from "./SidebarItem.vue?vue&type=template&id=ff0125b0&scoped=true&"
import script from "./SidebarItem.vue?vue&type=script&lang=js&"
export * from "./SidebarItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff0125b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/nisems/front/nisbos-front-admin/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff0125b0')) {
      api.createRecord('ff0125b0', component.options)
    } else {
      api.reload('ff0125b0', component.options)
    }
    module.hot.accept("./SidebarItem.vue?vue&type=template&id=ff0125b0&scoped=true&", function () {
      api.rerender('ff0125b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Layout/components/Sidebar/SidebarItem.vue"
export default component.exports